
import { put, select } from "redux-saga/effects";
import { metaLoaded, orderRowsMetaLoaded, getOrdersMeta } from '../selectors';
import { fetchOrdersSuccess, fetchOrderSuccess, setOrdersMeta, setOrderRowsMeta, toastrAdd } from "../actions";
import api from './../api';

export function* fetchOrdersSaga(action) {
	const metaIsLoaded = yield select(metaLoaded);
	const orderRowsMetaIsLoaded = yield select(orderRowsMetaLoaded);

	// Get meta if needed
	if(!metaIsLoaded && localStorage.getItem("token")) {
		try {
			const response = yield api.shop.getOrderRowsMeta();
			yield put(setOrdersMeta(response.data.data.meta));
		} catch (error) {
			console.log('cant fetch orders meta');
			yield put(toastrAdd({ details: "Can't get order rows meta", title: 'Error', type: 'error' }));
		}
	}

	if(!orderRowsMetaIsLoaded) {
		try {
			const response = yield api.shop.getOrderRowsMeta();
			yield put(setOrderRowsMeta(response.data.data.meta));
		} catch (error) {
			console.log('cant fetch orderRows meta');
			yield put(toastrAdd({ details: "Can't get orders rows meta", title: 'Error', type: 'error' }));
		}
	}

	// Get orders
	try {
		const meta = yield select(getOrdersMeta);
		const response = yield api.shop.getOrders(action.eventID);
		const orders = yield response.data.data.orders.map(order => {
			if (order) {
				if(order.statusText && meta.statuses[order.status]) {
					order.statusText = meta.statuses[order.status];
				}
			}
			return order
		});

		yield put(fetchOrdersSuccess(orders, response.data.meta));

	} catch (error) {
		// TODO
		console.log(error);
		yield put(toastrAdd({ details: "Can't get orders", title: 'Error', type: 'error' }));
	}
}

export function* fetchOrderSaga(action) {
	const orderRowsMetaIsLoaded = yield select(orderRowsMetaLoaded);
	if(!orderRowsMetaIsLoaded) {
		try {
			const response = yield api.shop.getOrderRowsMeta();
			yield put(setOrderRowsMeta(response.data.data.meta));
		} catch (error) {
			console.log('cant fetch orderRows meta');
			yield put(toastrAdd({ details: "Can't get order rows meta", title: 'Error', type: 'error' }));
		}
	}
	// Get orders
	try {
		const response = yield api.shop.getOrder(action.orderID, action.eventID);
		yield put(fetchOrderSuccess(response.data.data.order));
	} catch (error) {
		// TODO
		console.log(error);
		yield put(toastrAdd({ details: "Can't get order", title: 'Error', type: 'error' }));
	}
}
